import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "login-logo" }

import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import LoginForm from './LoginForm.vue';
import store from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

store.commit('app/UPDATE_LOADING', false);

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_unref(t)('info.name')), 1),
      _cache[0] || (_cache[0] = _createTextVNode(" Admin ", -1))
    ]),
    _createVNode(LoginForm)
  ]))
}
}

})